//
//
//
//
//

import storage from 'utils/storage'
export default {
  data () {
    return {
      historyFushiLink: false
    }
  },
  components: {
  },
  methods: {
    goFijiFilm () {
      console.log('0000000000000000000000000000')
      // var param = this.$route.params.selectedPic
      if (this.$route.params.selectedDetail) {
        storage.setItem('historyLink', 'filmSelfPrinter')
        this.$router.push({name: 'filmSelfPrinter', params: {selectedDetail: this.$route.params.selectedDetail}})
      } else if (this.$route.params.selectedPic) {
        storage.setItem('historyLink', 'fujiFilm')
        this.$router.push({name: 'fujiFilm', params: {selectedPic: this.$route.params.selectedPic}})
      } else {
        this.$router.push({name: storage.getItem('historyLink')})
      }
    }
  },
  created () {
    this.goFijiFilm()
  }
}



// WEBPACK FOOTER //
// ./src/views/blankPage/index.vue